import { Controller } from "@hotwired/stimulus"

// Live character counter: data-controller="char-counter" data-char-counter-max-value="60"
export default class extends Controller {
  static targets = ["input", "count"]
  static values = { max: Number }

  connect() {
    this.updateCount()
  }

  updateCount() {
    const current = this.inputTarget.value.length
    const max = this.maxValue
    this.countTarget.textContent = `${current} / ${max}`

    if (current > max) {
      this.countTarget.classList.add("text-red-600")
      this.countTarget.classList.remove("text-gray-400")
    } else {
      this.countTarget.classList.remove("text-red-600")
      this.countTarget.classList.add("text-gray-400")
    }
  }

  input() {
    this.updateCount()
  }
}
